'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _formattedFaxNumber = require('common/components/formatted-fax-number');

var _formattedFaxNumber2 = _interopRequireDefault(_formattedFaxNumber);

var _tooltip = require('common/components/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _multiSelect = require('common/components/multi-select');

var _multiSelect2 = _interopRequireDefault(_multiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FaxLineConfigEntry = _react2['default'].createClass({
    displayName: 'FaxLineConfigEntry',


    mixins: [_watchAppNotifier2['default']],

    propTypes: {
        hasMultiple: _react2['default'].PropTypes.bool.isRequired,
        teamMembers: _react2['default'].PropTypes.array.isRequired, // This should be allTeamMembers
        faxLine: function faxLine(props, propName, componentName) {
            if (props[propName].number === undefined) {
                throw new Error(propName + '.number must be defined for ' + componentName);
            }
            if (props[propName].statusCode === undefined) {
                throw new Error(propName + '.statusCode must be defined for ' + componentName);
            }
            if (props[propName].guid === undefined) {
                throw new Error(propName + '.guid must be defined for ' + componentName);
            }
        }
    },

    getInitialState: function getInitialState() {
        return {
            hasHover: false,
            isDeleting: false,
            statusMessage: null, // when not null, should be object in form of { text: '', className: '' }
            isPorting: this.props.faxLine.statusCode !== _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_ACTIVE
        };
    },
    handleMouseEnter: function handleMouseEnter() {
        this.setState({ hasHover: true });
    },
    handleMouseLeave: function handleMouseLeave() {
        this.setState({ hasHover: false });
    },
    handleDelete: function handleDelete() {
        if (!window.confirm('Are you sure you want to ' + (this.state.isPorting ? 'cancel porting for this number?' : 'remove this fax line? You will no longer be able to receive faxes at this number.'))) {
            return;
        }

        this.setState({ isDeleting: true });
        this.props.faxLine.remove();
    },
    handleSelectionChange: function handleSelectionChange(selectedTeamMemberGuids) {

        if (selectedTeamMemberGuids.length === 0) {
            this.setState({
                statusMessage: {
                    text: 'Cannot save. At least one recipient is required.',
                    className: 'error'
                }
            });
        } else {
            var onResult = function onResult(err) {
                if (!err) {
                    this.setState({ statusMessage: { text: 'Saved', className: 'success' } });
                } else {
                    this.setState({ statusMessage: { text: 'Error. Could not save.', className: '' } });
                }
            };

            this.props.faxLine.setMembers(this.props.teamMembers.filter(function (tm) {
                return !!~selectedTeamMemberGuids.indexOf(tm.guid);
            })).then(onResult.bind(this, void 0), onResult.bind(this));
        }
    },
    render: function render() {
        var hintText;
        var hintMsg;

        if (this.props.faxLine.isDenied()) {
            hintMsg = _react2['default'].createElement(
                'span',
                null,
                'Thank you for your interest in switching over to HelloFax! Unfortunately, we are unable to port this number at this time.'
            );
            hintText = _react2['default'].createElement(
                'span',
                null,
                'Porting not possible',
                _react2['default'].createElement(_tooltip2['default'], {
                    content: hintMsg,
                    text: '?',
                    arrowPosition: 'left'
                })
            );
        } else if (this.props.faxLine.isPorting()) {
            hintText = _react2['default'].createElement(
                'span',
                null,
                'Checking portability'
            );
        } else if (this.props.faxLine.isAccepted()) {
            hintMsg = _react2['default'].createElement(
                'span',
                null,
                _react2['default'].createElement(
                    'b',
                    null,
                    'Your number is portable!'
                ),
                _react2['default'].createElement('br', null),
                'Please check your email for the steps to complete your porting request.'
            );
            hintText = _react2['default'].createElement(
                'span',
                null,
                'Porting in progress',
                _react2['default'].createElement(_tooltip2['default'], {
                    content: hintMsg,
                    text: '?',
                    arrowPosition: 'left'
                })
            );
        } else if (this.props.faxLine.isActive()) {
            hintText = _react2['default'].createElement(
                'span',
                null,
                'Email inbound faxes to:'
            );
        }

        var deleteBtn = null;
        if (true || this.props.faxLine.statusCode === _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_STARTED || this.props.hasMultiple && (this.state.hasHover || this.state.isDeleting)) {
            deleteBtn = _react2['default'].createElement(
                'span',
                { onClick: this.handleDelete, className: 'remove-fax-line' + (this.state.isDeleting ? ' loading' : ''), 'data-fax-line-guid': this.props.faxLine.guid, 'data-fax-number': this.props.faxLine.number },
                _react2['default'].createElement('img', { className: 'spinner', src: _hfReactHelper2['default'].HfConstants.team_fax_lines.URLS.spinnerUrl, width: '16', height: '16' })
            );
        }

        var disabled = _hfReactHelper2['default'].inArray(this.props.faxLine.statusCode, [_hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_DENIED, _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_DENIED]) > -1;

        return _react2['default'].createElement(
            'div',
            { className: 'fax_line_select status-' + this.props.faxLine.statusCode, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
            _react2['default'].createElement(
                'h4',
                null,
                _react2['default'].createElement(
                    'span',
                    null,
                    _react2['default'].createElement(_formattedFaxNumber2['default'], { faxNumber: this.props.faxLine.number }),
                    ' - ',
                    _react2['default'].createElement(
                        'span',
                        { className: 'text' },
                        hintText
                    )
                ),
                deleteBtn
            ),
            _react2['default'].createElement(_multiSelect2['default'], { ref: 'multiSelect',
                className: 'fax_line_select',
                disabled: disabled,
                statusMessage: this.state.statusMessage,
                options: this.props.teamMembers.map(function (teamMember) {
                    return { key: teamMember.guid, descr: teamMember.emailAddress };
                }),
                onSelectionChange: this.handleSelectionChange,
                initiallySelectedOptionValues: this.props.faxLine.teamMembers.map(function (v) {
                    return v.guid;
                }),
                'data-fax-line-guid': this.props.faxLine.guid })
        );
    }
});

module.exports = FaxLineConfigEntry;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/team-fax-lines/config-entry.jsx
 ** module id = 1204
 ** module chunks = 0
 **/